/**
 * Action types class
 * Action类型
 */
export default class ActionTypes {
  static ADD_TO_CART = 'ADD_TO_CART';
  static ADD_TODO = 'ADD_TODO';
  static CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
  static CHECKOUT_SUCCESS = 'CHECKOUT_SUCCESS';
  static CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
  static INVALIDATE_SUBREDDIT = 'INVALIDATE_SUBREDDIT';
  static RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
  static RECEIVE_POSTS = 'RECEIVE_POSTS';
  static REQUEST_POSTS = 'REQUEST_POSTS';
  static SELECT_SUBREDDIT = 'SELECT_SUBREDDIT';
  static SET_VISIBILITY_FILTER = 'SET_VISIBILITY_FILTER';
  static SHOW_ALL = 'SHOW_ALL';
  static SHOW_COMPLETED = 'SHOW_COMPLETED';
  static SHOW_ACTIVE = 'SHOW_ACTIVE';
  static TOGGLE_TODO = 'TOGGLE_TODO';
}



// WEBPACK FOOTER //
// ./usr/lib/ui/src/actions/actionTypes.js